module.exports = __webpack_public_path__ + "static/img/J.cca96c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/J.png
// module id = R9td
// module chunks = 0